import type { SVGProps } from "react"

export const EmpoLogo = ({
	title = "Empo logo",
	...props
}: SVGProps<SVGSVGElement> & {
	title?: string
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 33 34"
		{...props}
	>
		<title>{title}</title>
		<path
			d="M31.1835 13.5586L19.7495 2.12465C17.8509 0.226028 14.7625 0.226028 12.8667 2.12465L1.43276 13.5586C-0.465867 15.4572 -0.465867 18.5456 1.43276 20.4414L12.8667 31.8754C14.7653 33.774 17.8537 33.774 19.7495 31.8754L31.1835 20.4414C33.0821 18.5428 33.0821 15.4544 31.1835 13.5586ZM7.84307 12.0453L11.3534 8.53497C12.0594 7.82896 13.207 7.82896 13.913 8.53497C14.619 9.24097 14.619 10.3886 13.913 11.0946L10.4027 14.6049C9.69669 15.3109 8.54908 15.3109 7.84307 14.6049C7.13706 13.8989 7.13706 12.7513 7.84307 12.0453ZM17.4543 29.2736C16.7483 29.9796 15.6007 29.9796 14.8947 29.2736L4.03457 18.4134C3.32857 17.7074 3.32857 16.5598 4.03457 15.8538C4.74058 15.1478 5.88819 15.1478 6.5942 15.8538L10.743 20.0026L16.7821 13.9636C17.4881 13.2576 18.6357 13.2576 19.3417 13.9636C20.0477 14.6696 20.0477 15.8172 19.3417 16.5232L13.3027 22.5623L17.4515 26.7111C18.1575 27.4171 18.1575 28.5647 17.4515 29.2707L17.4543 29.2736ZM24.7732 21.9547L21.2628 25.4651C20.5568 26.1711 19.4092 26.1711 18.7032 25.4651C17.9972 24.759 17.9972 23.6114 18.7032 22.9054L22.2135 19.3951C22.9195 18.6891 24.0672 18.6891 24.7732 19.3951C25.4792 20.1011 25.4792 21.2487 24.7732 21.9547ZM28.5817 18.1462C27.8757 18.8522 26.728 18.8522 26.022 18.1462L15.1619 7.28609C14.4559 6.58009 14.4559 5.43247 15.1619 4.72647C15.8679 4.02046 17.0155 4.02046 17.7215 4.72647L28.5817 15.5866C29.2877 16.2926 29.2877 17.4402 28.5817 18.1462Z"
			fill="#84C99A"
		/>
	</svg>
)
